//-- React Standard
import React, { Component } from "react";
import { connect } from 'react-redux';
//import compose from 'recompose/compose';
import config from '../../config';

//-- Custom
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";

import { withStyles } from "@material-ui/core/styles";
import Footer from "../Common/Footer/Footer";
import { apiConstants } from '../../_constants/api.constants';
import Pagination from "../Common/Pagination/Pagination";
import PageLimit from "../Common/PageLimit/PageLimit";
import { categoryActions, productActions, userActions } from "../../_actions";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import AddProducts from './AddProduct';
import EditProducts from './EditProduct';

//-- CSS for Material
const styles = theme => ({
    error: {
        color: 'red',
    },
    loaderImg: {
        margin: '0 auto',
        display: 'block',
        width: '250px'
    },
    root: {
        margin: 0,
        padding: theme.spacing(2),
        backgroundColor: "#269abc",
        color: '#fff'
    },
});

class Products extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sort: {
                sortKey: null,
                direction: 'desc',
            },
            totalPage: '',
            totalDataCount: '',
            currentPage: 1,
            getCouponList: [],
            productAdd: false,
            allCategories: [],
            soldIndChecked: false,
            editProductId: false,
            enableEdit: false,
            deletingProdId: false,
            deletePopup: false
        };
    }

    /*
    * componentDidMount - Initially it will call and get the advertisments data
    */
    componentDidMount() {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = config.perPageData;

        dispatch(productActions.getProducts(apiConstants.GET_PRODUCT_FOR_SHOPKEEPER, postData));
    }

    /*
    * componentWillReceiveProps - Whenever Props change, it will call and store data
    * update the state values with new props values, this method will get called whenever any change happens to props values
    */
    componentWillReceiveProps(props) {
        const { dispatch } = props;

        // check if product data returned by API
        if (props.getProduct !== undefined) {
            if (props.getProduct.Product !== undefined &&
                props.getProduct.Product.data !== undefined &&
                props.getProduct.Product.data.allData !== undefined) {

                const prodData = props.getProduct.Product.data;

                this.setState({
                    allProducts: prodData.allData,
                    totalPage: prodData.pagination.totalPages,
                    totalDataCount: prodData.pagination.totalCount,
                })
            }
        }

        if (props.deleteProduct !== undefined) {
            if (props.deleteProduct.deletedProduct !== undefined &&
                props.deleteProduct.deletedProduct.data !== undefined &&
                props.deleteProduct.deletedProduct.data.type === "product-deleted") {

                if (this.state.deletePopup === true) {
                    // hide the conformation popup
                    this.closeDeletePopup();
                    //reload the table products again
                    this.reloadTable();
                }

            }
        }
    }

    reloadTable = () => {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = config.perPageData;

        dispatch(productActions.getProducts(apiConstants.GET_PRODUCT_FOR_SHOPKEEPER, postData));
    }


    /*
    *   Pagination function: It will call from pagination section and change data in table
    */
    makeHttpRequestWithPage = (pageNumber) => {
        const { dispatch } = this.props;
        this.setState({
            currentPage: pageNumber
        });

        let postData = {};
        postData.page = pageNumber;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = config.perPageData;

        dispatch(productActions.getProducts(apiConstants.GET_PRODUCT_FOR_SHOPKEEPER, postData));
    }

    // hit api and get category data for selected list range
    changeTableData = (e) => {
        const { dispatch } = this.props;

        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = parseInt(e.target.value);

        dispatch(productActions.getProducts(apiConstants.GET_PRODUCT_FOR_SHOPKEEPER, postData));
    }

    /*
    * searchCategories - User can search data from the database and it will appear
    */
    searchCategories(keyword) {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = config.perPageData;


        if (keyword.target.value !== '') {
            postData.search = keyword.target.value;
            dispatch(productActions.getProducts(apiConstants.SEARCH_PRODUCT_BY_KEYWORD_FOR_SHOPKEEPER, postData));
        } else {
            dispatch(productActions.getProducts(apiConstants.GET_PRODUCT_FOR_SHOPKEEPER, postData));
        }
    }

    //open add product popup
    openAddProducts = () => { this.setState({ productAdd: true }) }

    //close add product popup
    closeAddProductPop = (data) => {
        const { dispatch } = this.props;
        this.setState({ productAdd: false });
        if (data === 1) {
            let postData = {};
            postData.page = 1;
            postData.orderBy = "id";
            postData.orderByAscDesc = "ASC";
            postData.perPage = config.perPageData;

            dispatch(productActions.getProducts(apiConstants.GET_PRODUCT_FOR_SHOPKEEPER, postData));
        }
    }

    //open edit product popup
    editProduct = (prodId) => { this.setState({ editProductId: prodId, enableEdit: true }) }

    //close edit product popup
    closeEditProductPop = (data) => {
        const { dispatch } = this.props;
        this.setState({ editProductId: false, enableEdit: false });
        if (data === 1) {
            let postData = {};
            postData.page = 1;
            postData.orderBy = "id";
            postData.orderByAscDesc = "ASC";
            postData.perPage = config.perPageData;

            dispatch(productActions.getProducts(apiConstants.GET_PRODUCT_FOR_SHOPKEEPER, postData));
        }
    }

    //delete product popup
    deletePopupOpen = (proId) => {
        this.setState({ deletingProdId: proId, deletePopup: true });
    }
    // close the popup and reset the id for deleting product
    closeDeletePopup = () => {
        this.setState({ deletingProdId: false, deletePopup: false });
    }

    //delete a product
    deletingProduct = () => {
        const { deletingProdId } = this.state;
        const { dispatch } = this.props;
        if (deletingProdId) {
            const postData = {};
            postData.productId = deletingProdId;
            dispatch(productActions.deleteProducts(apiConstants.DELETE_PRODUCT_BY_SHOPKEEPER, postData));
        }
    }


    //-- Main function
    render() {
        const { classes } = this.props;
        const { siteConstants } = this.props.language;
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return (
            <div id="wrapper">

                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />
                        <nav className="" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                </li>
                                <li className="active breadcrumb-item" aria-current="page">
                                    {siteConstants.MENU_PRODUCTS}
                                </li>
                            </ol>
                        </nav>

                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">

                            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                <h1 className="h3 mb-0 text-gray-800">{siteConstants.MENU_PRODUCTS}</h1>
                                <a href="javascript:void(0)"
                                    onClick={() => this.openAddProducts()}
                                >
                                    <span className="text">
                                        <button className="btn btn-primary">{siteConstants.BTN_ADD}</button>
                                    </span>
                                </a>

                            </div>


                            <div className="card shadow mb-4">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <div className="row">
                                            {/* Page limit drop down */}
                                            <PageLimit changeLimit={(e) => this.changeTableData(e)} />

                                            <div className="col-sm-12 col-md-6">
                                                <div id="dataTable_filter" className="dataTables_filter">
                                                    <label>
                                                        <input type="search" placeholder={siteConstants.GEN_SEARCH} className="form-control form-control-sm" aria-controls="dataTable" onChange={(e) => this.searchCategories(e)} />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>



                                        <table className="table table-bordered" width="100%" cellSpacing="0">
                                            <thead>
                                                <tr>
                                                    <th scope="col" width="5%">{siteConstants.GEN_NUMBER}</th>
                                                    <th scope="10%">{siteConstants.GEN_PRODUCT_TITLE}</th>
                                                    <th scope="col">{siteConstants.GEN_PRODUCT_REGULAR_PRICE}</th>
                                                    <th scope="col">Sell/Rent</th>
                                                    <th width="20%">{siteConstants.GEN_PRODUCT_CATEGORY}[Sub Category]</th>
                                                    <th width="8%">{siteConstants.GEN_PRODUCT_STOCK}</th>
                                                    <th width="8%">Size</th>
                                                    <th width="10%">{siteConstants.GEN_PRODUCT_ADDED_DATE}</th>
                                                    <th width="10%">{siteConstants.LABEL_ACTION}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.allProducts !== undefined &&
                                                        this.state.allProducts.length > 0 ?
                                                        this.state.allProducts.map((thisProd, index) => {
                                                            let crtdDate = new Date(thisProd.createdAt);
                                                            return (

                                                                <tr key={index}>
                                                                    <td scope="row">{index + 1}</td>
                                                                    <td>{thisProd.title}</td>
                                                                    <td>{config.currencyCode}{thisProd.regularPrice}</td>
                                                                    <td>{thisProd.productSoldIndividually == 1 ? <p style={{ color: 'red' }}>Sell</p> : 'Rent'}</td>
                                                                    <td>{thisProd.categoryData.length > 0 ? thisProd.categoryData[0].categoryTitle : '--'} <b>[</b>{thisProd.subCategoryData.length > 0 ? thisProd.subCategoryData[0].categoryTitle : '--'}<b>]</b></td>
                                                                    <td>{thisProd.inStock}</td>
                                                                    <td>{thisProd.productAttributes ? thisProd.productAttributes.Size :'Free'}</td>
                                                                    <td>
                                                                        {crtdDate !== undefined ? crtdDate.toLocaleString("en-US", options) : ''}
                                                                    </td>
                                                                    <td className="tdTextCenter">
                                                                        <a
                                                                            className="actionIcon"
                                                                            title="Edit"
                                                                            href="javascript:void(0)"
                                                                            onClick={() => this.editProduct(thisProd._id)}
                                                                        ><span><img src="assets/img/svg/EditIcon.png" alt="Edit" /></span></a>
                                                                        <a className="actionIcon"
                                                                            title="Delete"
                                                                            href="javascript:void(0)"
                                                                            onClick={() => this.deletePopupOpen(thisProd._id)}
                                                                        ><span><img src="assets/img/svg/Bin.png" alt="Delete" /></span>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }) : <tr>
                                                            <td colSpan="9" className="noRecordFound">{siteConstants.GEN_NO_RECORD}</td>
                                                        </tr>
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                    {/* calling the another componenet */}
                                    <Pagination totalPage={this.state.totalPage} currentPage={this.state.currentPage} funPagination={this.makeHttpRequestWithPage} />



                                </div>
                            </div>

                        </div>
                        {/* <!-- /.container-fluid --> */}

                    </div>
                    {/* <!-- End of Main Content --> */}

                    {/* add product popup */}
                    {
                        this.state.productAdd === true ? <AddProducts displayPopUp={this.state.productAdd} closeAddProductPop={(data) => this.closeAddProductPop(data)} /> : ''
                    }

                    {/* edit product popup */}
                    {
                        this.state.editProductId !== false ? <EditProducts editProductId={this.state.editProductId} displayPopUp={this.state.enableEdit} closeEditProductPop={(data) => this.closeEditProductPop(data)} /> : ''
                    }

                    {/* add product popup */}
                    <Footer />
                    {/* notify saving data */}
                    {/* <Dialog open={this.state.deletePopup} aria-labelledby="delete-product-notify" >
                        <DialogTitle>{siteConstants.GEN_ARE_SURE_TO_DELETE}</DialogTitle>
                        <DialogActions>
                            <Button variant="contained" color="primary" onClick={(e) => this.deletingProduct(e)}>{siteConstants.GEN_DELETE_THIS}</Button>
                            <Button variant="contained" onClick={() => this.closeDeletePopup(0)}>{siteConstants.LABEL_CANCEL}</Button>
                        </DialogActions>
                    </Dialog> */}

                    {/* notify about delete */}
                    <Dialog open={this.state.deletePopup} aria-labelledby="delete-tax-notify" >
                        <DialogTitle className={classes.root}>
                            {siteConstants.BTN_DELETE}
                        </DialogTitle>
                        <DialogContent>
                            {siteConstants.LABEL_SURE_DELTE_TAX_RECORD}
                        </DialogContent>
                        <DialogActions>
                            <Button variant="contained" color="primary" onClick={(e) => this.deletingProduct(e)}>{siteConstants.GEN_DELETE_THIS}</Button>
                            <Button variant="contained" onClick={() => this.closeDeletePopup(0)}>{siteConstants.LABEL_CANCEL}</Button>
                        </DialogActions>
                    </Dialog>

                </div>
            </div>
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { language, getProduct, deleteProduct } = state;
    return {
        language,
        getProduct,
        deleteProduct
    };
}
export default connect(mapStateToProps)(withStyles(styles)(Products))
